import { saURL } from 'endpoints';
import fetch from '../../../utils/fetch';
import { startLoading, endLoading } from '../../../app-dux/app-dux';
import rosterSdk from '../../../services/roster-sdk';

/*******************************************************************************
 * Initial state
 */
const initialState = {
    filterOptions: {}
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';

/*******************************************************************************
 * Reducer
 */
export default function reportsPageReducer( state = initialState, action ) {
    switch ( action.type ) {
        case SET_FILTER_OPTIONS:
            return {
                ...state,
                filterOptions: action.filterOptions
            };
        default:
            return state;
    }
}

/*******************************************************************************
 * Action creators
 */

export function loadFilterOptions() {
    return async ( dispatch ) => {
        dispatch( startLoading() );

        try {
            const res = await fetch( `${ saURL }/report/filter-options`, {
                method: 'GET',
                headers: {
                    'content-type': 'application/json'
                }
            } );
            const data = await res.json();
            if ( res.ok ) {
                const { hierarchies } = await rosterSdk.getHierarchies();
                data.hierarchies = hierarchies;

                dispatch( setFilterOptions( data ) );
            } else {
                dispatch( setFilterOptions( {} ) );
            }
            dispatch( endLoading() );
            return data;

        } catch {
            dispatch( endLoading() );
        }
    };

}

function setFilterOptions( filterOptions ) {
    return {
        type: SET_FILTER_OPTIONS,
        filterOptions
    };
}
